import React, { Fragment, useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  ButtonToolbar,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonGroup,
} from 'reactstrap';
import { reduxForm, Field } from 'redux-form';
import { v4 as uuid } from 'uuid';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SendIcon from '@material-ui/icons/Send';
import ReactRouterPropTypes from 'react-router-prop-types';
import { format } from 'date-fns';
import { connect } from 'react-redux';
import validate from './Validate';
import SmartHtmlEditor from '../../../shared/components/form/SmartHtmlEditor';
import {
  relationObjectListByCommunicationId,
  relationObjectListByParamsAndCourseStepQuery,
} from '../../../shared/queries/RelationObject';
import GraphQl from '../../../GraphQL';
import renderDropZoneMultipleField from '../../../shared/components/form/DropZoneMultiple';
import SmartContext from '../../App/context/SmartContext';
import {
  COMMUNICATION_TYPE,
  SUPPORTED_POST_FORMATS,
  ATTACHMENT_TYPES,
  EXAM_EVALUATION_TYPE,
} from '../../../shared/utils/constants';
import QuestionCard from './questionnaire/QuestionCard';
import Questionnaire from './questionnaire/Questionnaire';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import TaskFields from './fields/TaskFields';
import ExamFields from './fields/ExamFields';
import SchedulerModal from '../../../shared/components/SchedulerModal';
import { sleep } from '../../../shared/utils/smartutils';
import communicationQuestionRelationFindByCommunicationIdQuery from '../../../shared/queries/CommunicationQuestionRelation';
import { communicationFileListByCommunicationId } from '../../../shared/queries/Communication';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import AvailableToSelector from '../../CommunicationChannel/components/AvailableToSelector';
import ConfirmSendModal from './ConfirmSendModal';
import OccurrenceFields from './fields/OccurrenceFields';
import PostFields from './fields/PostFields';
import SurveyFields from './fields/SurveyFields';
import AuthorizationFields from './fields/AuthorizationFields';
import ClassPlanFields from '../../ClassPlan/components/FormHandler';
import courseStepFindByAccess from '../../../shared/queries/CourseStep';
import { subjectListByEmployeeQuery } from '../../../shared/queries/Subject';
import DateField from '../../../shared/components/form/DateField';

const CommunicationForm = (props) => {
  const {
    t,
    backHandler,
    handleSubmit,
    change,
    initialize,
    dto,
    history,
    dispatch,
    formValues,
    type,
  } = props;
  const [questions, setQuestions] = useState([]);
  const [questionToEdit, setQuestionToEdit] = useState({});
  const [schedulerModal, setSchedulerModal] = useState(false);
  const context = useContext(SmartContext);
  const { addFile, removeFiles } = context;
  const [supportedMimeTypes, setsupportedMimeTypes] = useState();
  const [supportedExtensions, setsupportedExtensions] = useState();
  const [editable, setEditable] = useState(true);
  const [confirmSendModal, setConfirmSendModal] = useState(false);
  const [htmlContent, setHtmlContent] = useState(dto.htmlContent);
  const [listOfCourseStep, setListOfCourseStep] = useState([]);
  const [recipients, setRecipients] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [cycles, setCycles] = useState([]);
  const evaluationTypes = [
    {
      value: EXAM_EVALUATION_TYPE.SUM,
      label: t(`communication.evaluation-type.${EXAM_EVALUATION_TYPE.SUM}`),
    },
    {
      value: EXAM_EVALUATION_TYPE.AVG,
      label: t(`communication.evaluation-type.${EXAM_EVALUATION_TYPE.AVG}`),
    },
    {
      value: EXAM_EVALUATION_TYPE.CONCEPT,
      label: t(`communication.evaluation-type.${EXAM_EVALUATION_TYPE.CONCEPT}`),
    },
  ];

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const onScheduleItemChange = (date) => {
    change('scheduled', true);
    change('scheduledTo', date.getTime());
    change('scheduledToHour', format(date, 'HH:mm'));
    change(
      'scheduledToDate',
      ` ${format(date, 'dd/MM/yyyy')} ${t('general.at')} ${format(
        date,
        'HH:mm'
      )}`
    );
  };

  const onScheduleItemCancelChange = () => {
    change('scheduled', false);
    change(
      'scheduledTo',
      new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        new Date().getHours() + 1,
        0,
        0
      ).getTime()
    );
    change('scheduledToHour', null);
    change('scheduledToDate', null);
  };

  function addInfoContent() {
    if (dto.sent) {
      return (
        <div className="info-panel success">
          <div className="content">
            <SendIcon fontSize="small" />
            <span className="message">{`${t('communication.sent-at-message')} ${
              dto.sentAtDateHour
            } `}</span>
          </div>
        </div>
      );
    }
    if (
      dto.scheduled ||
      (Object.keys(formValues).length !== 0 && formValues.values.scheduled)
    ) {
      return (
        <div className="info-panel info">
          <div className="content">
            <ScheduleIcon fontSize="small" />
            <span className="message">{`${t(
              'communication.scheduled-to-message'
            )} ${
              dto.scheduledToDate || formValues.values.scheduledToDate
            }`}</span>
            <Button
              className="link-button"
              outline
              size="sm"
              onClick={onScheduleItemCancelChange}
            >
              {`${t('communication.cancel-schedule')}`}
            </Button>
          </div>
        </div>
      );
    }
    return null;
  }

  const loadAddedRecipients = () => {
    showLoading();
    const query = relationObjectListByCommunicationId(dto.id);
    GraphQl(query, {})
      .then((res) => {
        res.relationObjectListByCommunicationId =
          res.relationObjectListByCommunicationId.map((item) => ({
            ...item,
            value: item.identifier,
            label: item.description,
          }));
        change('recipients', res.relationObjectListByCommunicationId);
        hideLoading();
      })
      .catch((error) => {
        console.error(error);
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const onDropZoneChange = (values) => {
    values.forEach((element) => {
      if (element.uploadType === ATTACHMENT_TYPES.VIMEO) {
        addFile({
          status: 'pending',
          content: element,
        });
      }
    });
    if (values) {
      change('files', values);
    } else {
      change('files', []);
    }
    removeFiles(values);
  };

  const onContentChange = (value, textValue) => {
    change('htmlContent', value);
    change('textContent', textValue);
  };

  const onQuestionAddHandler = (q) => {
    const updatedQuestions = [...questions];
    let qIndex = -1;
    if (q.hashId) {
      qIndex = updatedQuestions.findIndex(
        (question) => question.hashId === q.hashId
      );
    }
    if (qIndex >= 0) {
      updatedQuestions[qIndex] = { ...q };
    } else {
      updatedQuestions.push({
        ...q,
        hashId: uuid(),
      });
    }
    setQuestions(updatedQuestions);
  };

  const onQuestionEditClickHandler = (questionHashId) => {
    const selectedQuestion = questions.find((q) => q.hashId === questionHashId);
    setQuestionToEdit({ ...selectedQuestion });
  };

  const onQuestionRemoveClickHandler = (questionHashId) => {
    const updatedQuestions = questions.filter(
      (q) => q.hashId !== questionHashId
    );
    setQuestions(updatedQuestions);
  };

  const toggleSchedulerModal = () => {
    setSchedulerModal(!schedulerModal);
  };

  const toggleSendConfirmModal = () => {
    setConfirmSendModal(!confirmSendModal);
  };

  const validateCommunicationSurvey = () => {
    return (
      formValues.values.type === COMMUNICATION_TYPE.SURVEY &&
      (!formValues.values.questions || !formValues.values.questions.length)
    );
  };

  const onSaveClickHandler = (send) => {
    if (formValues && formValues.values) {
      if (validateCommunicationSurvey()) {
        showNotificationAutoDestroy(
          'warning',
          t('warnings.title'),
          t('question.validation.required-min-question-survey')
        );
      } else if (!dto.sent) {
        change('sent', send);
        showLoading();
        if (confirmSendModal) {
          toggleSendConfirmModal();
        }
        sleep(1000).then(() => {
          handleSubmit();
          hideLoading();
        });
      } else {
        handleSubmit();
      }
    }
  };

  const onConfirmSendHandler = () => {
    if (formValues.values && formValues.values.scheduledToDate) {
      toggleSendConfirmModal();
    } else {
      onSaveClickHandler(true);
    }
  };

  const loadQuestions = () => {
    const query = communicationQuestionRelationFindByCommunicationIdQuery(
      dto.id
    );
    if (query) {
      GraphQl(query, {})
        .then((res) => {
          if (res.communicationQuestionRelationFindByCommunicationId.length) {
            const questionsList =
              res.communicationQuestionRelationFindByCommunicationId.map(
                (q) => ({
                  ...q.question,
                  type: {
                    value: q.question.type,
                    label: t(`question.type-description.${q.question.type}`),
                  },
                })
              );
            setQuestions(questionsList);
          }
        })
        .catch((error) => {
          console.error(error);
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        });
    }
  };

  const loadSupportedFormats = () => {
    const mappedMimeTypes = SUPPORTED_POST_FORMATS.map(
      (formatType) => formatType.mimeType
    );
    const mappedDescriptions = SUPPORTED_POST_FORMATS.map(
      (formatType) => formatType.description
    );

    setsupportedMimeTypes(mappedMimeTypes);
    setsupportedExtensions(mappedDescriptions);
  };

  const loadFiles = (id) => {
    const query = communicationFileListByCommunicationId(id);
    GraphQl(query, {})
      .then((res) => {
        const loadedFiles = res.communicationFileListByCommunicationId.map(
          (file) => ({
            preview: file.fileUrl,
            type: file.fileType,
            fileType: file.fileType,
            fileId: file.fileId,
            fileUrl: file.fileUrl,
            order: 0,
            communicationId: dto.id,
            id: 0,
            fileName: file.fileName,
            status: file.status,
          })
        );
        change('files', loadedFiles);
      })
      .catch((error) => {
        console.error(error);
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const onTemplateChange = (newTemplate) => {
    if (newTemplate.title) {
      change('title', newTemplate.title);
    }
  };

  const createListOfCycles = (cycleQuantity) => {
    const listOfCycles = [];
    for (let i = 1; i <= cycleQuantity; i += 1) {
      listOfCycles.push({ value: i, label: `${i}º` });
    }
    setCycles(listOfCycles);
  };

  const loadRecipients = (courseStepId) => {
    showLoading();
    const query = relationObjectListByParamsAndCourseStepQuery(
      false,
      false,
      false,
      false,
      courseStepId
    );
    GraphQl(query, {})
      .then((res) => {
        res.relationObjectListByParamsAndCourseStep =
          res.relationObjectListByParamsAndCourseStep.map((item) => ({
            ...item,
            value: item.identifier,
            label: item.description,
          }));
        setRecipients(res.relationObjectListByParamsAndCourseStep);
        hideLoading();
      })
      .catch((error) => {
        console.error(error);
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadCourseStepsChangeHandler = (value) => {
    if (value) {
      loadRecipients(value.id);
      createListOfCycles(value.cycleQuantity);
    } else {
      setRecipients([]);
    }
  };

  const loadCourseSteps = (employeeId) => {
    showLoading();
    const query = courseStepFindByAccess(employeeId);
    GraphQl(query, {})
      .then((res) => {
        setListOfCourseStep(res.courseStepFindByAccess);
        hideLoading();
      })
      .catch((error) => {
        console.error(error);
        hideLoading();
      });
  };

  const loadSubjects = (employeeId) => {
    showLoading();
    const query = subjectListByEmployeeQuery(employeeId);
    GraphQl(query, {})
      .then((res) => {
        res.subjectListByEmployee = res.subjectListByEmployee.map((subj) => ({
          ...subj,
          value: subj.id,
          label: subj.name,
        }));
        setSubjects(res.subjectListByEmployee);
        if (res.subjectListByEmployee.length === 1) {
          change('examHeader.subject', {
            ...res.subjectListByEmployee[0],
            value: res.subjectListByEmployee[0].id,
            label: res.subjectListByEmployee[0].name,
          });
        }
        hideLoading();
      })
      .catch((error) => {
        console.error(error);
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const hasDueDate = () => {
    return (
      dto.type === COMMUNICATION_TYPE.SURVEY ||
      dto.type === COMMUNICATION_TYPE.AUTHORIZATION
    );
  };

  const isSurveyCommunication = () => dto.type === COMMUNICATION_TYPE.SURVEY;

  const isAuthorizationCommunication = () =>
    dto.type === COMMUNICATION_TYPE.AUTHORIZATION;

  useEffect(() => {
    change('questions', questions);
  }, [questions]);

  useEffect(() => {
    if (dto.id) {
      if (
        dto.type === COMMUNICATION_TYPE.SURVEY ||
        dto.type === COMMUNICATION_TYPE.AUTHORIZATION ||
        dto.type === COMMUNICATION_TYPE.ACTIVITY ||
        dto.type === COMMUNICATION_TYPE.EXAM
      ) {
        if (!dto.editable) {
          let message = '';
          if (dto.type === COMMUNICATION_TYPE.SURVEY) {
            message = t('notifications.search-answered');
          } else if (dto.type === COMMUNICATION_TYPE.AUTHORIZATION) {
            message = t('notifications.authorization-answered');
          } else {
            message = t('notifications.task-closed');
          }
          setEditable(dto.editable);
          showNotificationAutoDestroy(
            'warning',
            t('notifications.attention'),
            message
          );
        }
      }
      loadAddedRecipients();
      loadQuestions();
      loadFiles(dto.id);
    }
    initialize(dto);
    if (dto.examHeader && dto.examHeader.courseStep) {
      loadRecipients(dto.examHeader.courseStep.id);
      loadSubjects(dto.examHeader.teacher.id);
      createListOfCycles(dto.examHeader.courseStep.cycleQuantity);
      const evaluationType = evaluationTypes.find(
        (item) => item.value === dto.examHeader.evaluationType
      );
      change('examHeader.evaluationType', evaluationType);
    }
  }, [dto]);

  useEffect(() => {
    loadSupportedFormats();
  }, []);

  return (
    <Fragment>
      <SchedulerModal
        isOpen={schedulerModal}
        toggleFunction={toggleSchedulerModal}
        onScheduleFinish={onScheduleItemChange}
        initialDate={dto.scheduledTo}
      />
      <ConfirmSendModal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={
          formValues.values && formValues.values.scheduledToDate
            ? t('communication.confirmSend').replace(
                '[?]',
                formValues.values.scheduledToDate
              )
            : null
        }
        toggle={toggleSendConfirmModal}
        modal={confirmSendModal}
        onCancel={() => onSaveClickHandler(false)}
        onConfirm={() => onSaveClickHandler(true)}
      />
      {addInfoContent()}
      <form className="form" onSubmit={handleSubmit}>
        {dto.type === COMMUNICATION_TYPE.ACTIVITY ? (
          <TaskFields
            showLoading={showLoading}
            hideLoading={hideLoading}
            change={change}
            editable={editable}
          />
        ) : null}
        {dto.type === COMMUNICATION_TYPE.EXAM ? (
          <ExamFields
            showLoading={showLoading}
            hideLoading={hideLoading}
            change={change}
            editable={editable}
            history={history}
            loadCourseSteps={loadCourseSteps}
            listOfCourseStep={listOfCourseStep}
            loadRecipients={loadRecipients}
            recipients={recipients}
            setRecipients={setRecipients}
            subjects={subjects}
            loadSubjects={loadSubjects}
            evaluationTypes={evaluationTypes}
            cycles={cycles}
            loadCourseStepsChangeHandler={loadCourseStepsChangeHandler}
          />
        ) : null}
        {hasDueDate() && (
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t(`communication.due-date-${dto.type}`)}
            </span>
            <div className="form__form-group-field">
              <Field
                name="dueDate"
                minDate={new Date()}
                component={DateField}
                placeholder={t(
                  `communication.placeholders.due-date-${dto.type}`
                )}
                disabled={!editable}
              />
            </div>
          </div>
        )}
        {dto.type === COMMUNICATION_TYPE.OCCURRENCE ? (
          <OccurrenceFields
            showLoading={showLoading}
            hideLoading={hideLoading}
            change={change}
            editable={editable}
            changeHtmlContent={setHtmlContent}
          />
        ) : null}
        {dto.type === COMMUNICATION_TYPE.POST ? (
          <PostFields
            showLoading={showLoading}
            hideLoading={hideLoading}
            change={change}
            editable={editable}
          />
        ) : null}
        {dto.type === COMMUNICATION_TYPE.SURVEY ? (
          <SurveyFields
            showLoading={showLoading}
            hideLoading={hideLoading}
            change={change}
            editable={editable}
          />
        ) : null}
        {dto.type === COMMUNICATION_TYPE.AUTHORIZATION ? (
          <AuthorizationFields
            showLoading={showLoading}
            hideLoading={hideLoading}
            change={change}
            editable={editable}
          />
        ) : null}
        {dto.type === COMMUNICATION_TYPE.PLAN ? <ClassPlanFields /> : null}
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.message')}</span>
          <Field
            name="htmlContent"
            component={SmartHtmlEditor}
            onEditorChange={onContentChange}
            onTemplateSelect={onTemplateChange}
            htmlValue={dto.htmlContent}
            readOnly={!editable}
            foreignContent={htmlContent}
            showTemplateCommunication={type !== COMMUNICATION_TYPE.OCCURRENCE}
          />
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.attachments')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="files"
              accept={supportedMimeTypes}
              component={renderDropZoneMultipleField}
              onChange={onDropZoneChange}
              fileExtensions={supportedExtensions}
              disabled={!editable}
            />
          </div>
        </div>
        {isSurveyCommunication() ? (
          <Questionnaire
            onQuestionAdd={onQuestionAddHandler}
            questionToEdit={questionToEdit}
            subtitle={t('question.questionnaire')}
            hideQuestionnaire={false}
            editable={editable}
          />
        ) : null}
        {!isAuthorizationCommunication() &&
          questions.map((item) => (
            <QuestionCard
              key={uuid()}
              question={item}
              onEditClick={() => onQuestionEditClickHandler(item.hashId)}
              onRemoveClick={() => onQuestionRemoveClickHandler(item.hashId)}
              hideQuestionnaire={false}
            />
          ))}
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.visible-to')}
          </span>
          <div className="form__form-group-field">
            <Field name="visibleTo" component={AvailableToSelector} t={t} />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          {!dto.sent ? (
            <UncontrolledDropdown>
              <ButtonGroup>
                <Button
                  color="warning"
                  name="btnSend"
                  onClick={onConfirmSendHandler}
                  disabled={!editable}
                >
                  {t('general.send')}
                </Button>

                <DropdownToggle
                  color="warning"
                  className="icon icon--right"
                  disabled={!editable}
                >
                  <ChevronDownIcon />
                </DropdownToggle>
              </ButtonGroup>
              <DropdownMenu right className="dropdown__menu">
                <DropdownItem onClick={toggleSchedulerModal}>
                  <ScheduleIcon />
                  {t('general.schedule-to-send')}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          ) : null}
          <Button
            color="success"
            name="btnSave"
            onClick={() => onSaveClickHandler(false)}
            disabled={!editable}
          >
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

CommunicationForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  formValues: PropTypes.shape(PropTypes.shape),
  type: PropTypes.string.isRequired,
};

CommunicationForm.defaultProps = {
  formValues: {},
};

export default reduxForm({
  form: 'CommunicationForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(
  withTranslation('common')(
    connect((state) => ({
      formValues: state.form.CommunicationForm,
    }))(CommunicationForm)
  )
);
